<script>
export default {
  name: 'input-text',
  props: {
    placeHolder: {
      type: String,
      require: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<template>
  <div>
    <transition name="slot-error" appear>
      <span class="error" v-if="$slots.default">
        <slot></slot>
      </span>
    </transition>
    <input type="text" v-model.trim="inputVal" :placeholder="placeHolder" />
  </div>
</template>

<style scoped lang="scss">
.slot-error-enter-active,
.slot-error-leave-active {
  transition: all 0.3s ease;
}

.slot-error-enter,
.slot-error-leave-to {
  transform: translateY(50%);
  opacity: 0;
}

div {
  position: relative;
  z-index: 10;
}

input {
  width: 100%;
  padding: var(--size-5) 0 var(--size-5) var(--size-5);

  font-size: var(--fs-5-3);

  color: hsl(var(--clr-accent-100));
  background-color: hsl(var(--clr-primary-700));
  border: 1px solid hsl(var(--clr-accent-500));
  border-radius: 5px;
}

input::placeholder {
  font-size: var(--fs-4-3);
  color: hsl(var(--clr-accent-100));
}

.error {
  position: absolute;
  top: -20px;
  left: 4px;
  z-index: 9;
  color: hsl(var(--clr-accent-500));
  font-size: var(--fs-3-2);

  @media (max-width: 900px) {
    top: -15px;
  }
}
</style>
